export default [
  {
    path: '/inicio',
    name: 'inicio',
    component: () => import(/* webpackChunkName: "home" */ '../../views/inicio/Inicio')
  }
]
